import facebook from "@assets/share/facebook.svg";
import telegram from "@assets/share/tg.svg";
import tiktok from "@assets/share/tiktok.svg";
import wechat from "@assets/share/wechat.svg";
import youtube from "@assets/share/youtube.svg";
import Link from "@components/Link";
import clsx from "clsx";
import type { ReactElement } from "react";

const mediaList = [
  {
    name: "wechat",
    url: "/about-us?ref=footer-page",
    img: wechat,
  },
  {
    name: "tiktok",
    url: "https://www.tiktok.com/@redants.sg",
    img: tiktok,
  },
  {
    name: "facebook",
    url: "https://www.facebook.com/RedAnts.SG/",
    img: facebook,
  },
  {
    name: "youtube",
    url: "https://www.youtube.com/c/RedAntsSG",
    img: youtube,
  },
  {
    name: "telegram",
    url: "https://t.me/redantssg",
    img: telegram,
  },
];

type SocialMediaProps = {
  className?: string;
  media?: {
    name: string;
    url: string;
    img: string;
  }[];
};

export default function SocialMedia({
  className,
  media = mediaList,
}: SocialMediaProps): ReactElement {
  return (
    <section className="flex" data-testid="redants-social-media">
      {media.map((item, index) => (
        <Link
          key={index}
          to={item.url}
          className={clsx(
            "mr-[16px] flex size-[32px] items-center justify-center rounded-full bg-button-secondary transition-all hover:bg-button-secondary-hover",
            className,
          )}
          data-testid={`social-media-${item.name}`}
        >
          <img className="size-full" src={item.img} alt={item.name} />
        </Link>
      ))}
    </section>
  );
}
